import React, { useEffect, useMemo, useState } from 'react';
import { Tabs, Modal, Image } from 'antd';
import UploadMedia from './upload-media';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import getImage from 'helpers/getImage';
import ImageGallery from '../image-gallery';
import { t } from 'i18next';
import { useSelector } from 'react-redux';

const SELLER_RESTRICTED_FOLDERS = [
  'users',
  'languages',
  'deliveryman',
  'order_refunds',
  'referral',
  'blogs',
  'deliveryman/settings',
  'banners',
  'coupons',
  'order-refunds',
  'warehouses',
  'order-details',
  'ads-package',
  'other',
  'banner-title-img',
  'announcements'
];

const MediaUpload = ({
  imageList = [],
  setImageList,
  form,
  type,
  multiple = true,
  name,
  disabled,
  text = 'upload',
}) => {
  const role = useSelector((state) => state.auth?.user?.role);
  const isAdminOrManager = role === 'admin' || role === 'manager';
  const isSeller = role === 'seller';
  const showMediaTab = isAdminOrManager || isSeller;
  const [activeTabKey, setActiveTabKey] = useState(() =>
    showMediaTab ? 'item-1' : 'item-2',
  );
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [fileList, setFileList] = useState([]);

  useEffect(() => {
    setActiveTabKey(showMediaTab ? 'item-1' : 'item-2');
  }, [showMediaTab]);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setLoadingBtn(false);
    setFileList([]);
  };

  const removeImg = (path) => {
    const nextArray = imageList.filter((item) => item.name !== path.name);
    form.setFieldsValue({
      images: nextArray,
    });
    setImageList(nextArray);
  };

  const sellerFolderFilter = useMemo(() => {
    if (!isSeller) {
      return undefined;
    }
    return (folder) => !SELLER_RESTRICTED_FOLDERS.includes(folder);
  }, [isSeller]);

  return (
    <>
      <div className='media-upload-wrapper'>
        {imageList
          ?.filter((item) => !item?.isVideo)
          .map((item, idx) => (
            <div
              key={idx}
              className='image-wrapper'
              onClick={() => (disabled ? undefined : removeImg(item))}
            >
              <Image
                preview={false}
                src={getImage(item?.name)}
                className='images'
                alt={'images'}
              />
              <DeleteOutlined color='white' hidden={disabled} />
            </div>
          ))}
        {(multiple || !imageList.length) && (
          <div className='media-upload' onClick={showModal}>
            <PlusOutlined /> <span>{t(text)}</span>
          </div>
        )}
      </div>
      <Modal
        onCancel={handleCancel}
        maskClosable={true}
        visible={isModalOpen}
        footer={false}
        width={'80%'}
        bodyStyle={{ overflow :"auto", height: '90vh', display: 'flex', flexDirection: 'column' }}
      >
        <Tabs
          activeKey={activeTabKey}
          onChange={setActiveTabKey}
          destroyInactiveTabPane
          style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'auto' }}
          className='media-tabs-full-height'
          items={[
            showMediaTab && {
              key: 'item-1',
              label: 'Media files',
              children: (
                <div style={{ flex: 1, height: '100%', overflow: 'auto' }}>
                  <UploadMedia
                    form={form}
                    setImageList={setImageList}
                    imageList={imageList}
                    setIsModalOpen={setIsModalOpen}
                    name={name}
                    typeFilter={sellerFolderFilter}
                  />
                </div>
              ),
            },
            {
              key: 'item-2',
              label: 'Upload media',
              children: (
                <div
                  style={{
                    flex: 1,
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  <ImageGallery
                    type={type}
                    form={form}
                    fileList={fileList}
                    setFileList={setFileList}
                    imageList={imageList}
                    setImageList={setImageList}
                    multiple={multiple}
                    loadingBtn={loadingBtn}
                    setLoadingBtn={setLoadingBtn}
                    handleClose={handleCancel}
                  />
                </div>
              ),
            },
          ].filter(Boolean)}
        />
      </Modal>
    </>
  );
};
export default MediaUpload;
